import { render } from "./Mensaje.vue?vue&type=template&id=f4ffe5f8&scoped=true"
import script from "./Mensaje.vue?vue&type=script&lang=js"
export * from "./Mensaje.vue?vue&type=script&lang=js"

import "./Mensaje.vue?vue&type=style&index=0&id=f4ffe5f8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f4ffe5f8"

export default script